import { decrypt } from "../../../utils/encodingdecoding";
import { starblazeMerchantId } from "../../../utils";

export const getColumns = () => {
    const merchantCode = localStorage.getItem("Id");
    const isSuperonMerchant =
        decrypt(merchantCode) === starblazeMerchantId;

    return [
        {
            Header: "QR Code",
            Footer: "QR Code",
            accessor: "encryptCode",
        },
        {
            Header: "Created Date",
            Footer: "Created Date",
            accessor: "createddate",
        },
        ...(isSuperonMerchant
            ? [{
                Header: "Scan Date",
                Footer: "Scan Date",
                accessor: "scandate",
            }]
            : []),
        {
            Header: "Scan Action",
            Footer: "Scan Action",
            accessor: "status",
        },
    ]
};
